import React, { useRef, useEffect, useState } from 'react';
import FuseAnimate from '@fuse/core/FuseAnimate';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
// import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import JWTLoginTab from './tabs/JWTLoginTab';
// import EncompassLoginButton from './tabs/EncompassLoginButton';
import videoBackground from '../../../../src/background/videos/icentral-homepage-background-compressed.mp4';
import backgroundMusic from '../../../../src/background/music/loop.m4a';
import { VolumeUp, VolumeOff } from '@material-ui/icons';

const useStyles = makeStyles(() => ({
  root: {},
  leftSection: {
    background: '#FFF',
    color: 'black'
  },
  rightSection: {
    background: '#FFF',
    color: 'black',
    position: 'relative',
    maxWidth: '38.1rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2.2rem'
  },
  loginForm: {
    maxWidth: '34rem',
    padding: '0 !important'
  },
  loginLogo: {
    marginRight: '0',
    filter: 'brightness(0.85)',
    maxWidth: '397px',
    '@media screen and (max-width: 959px)': {
      maxWidth: '310px !important'
    }
  },
  loginModal: {
    padding: '70px 0',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
    maxWidth: '89.8rem !important',
    position: 'relative',
    '@media screen and (max-width: 959px)': {
      display: 'block !important',
      maxWidth: '36rem !important'
    }
  },
  loginModalCredentials: {
    padding: '30px !important',
    '@media screen and (max-width: 959px)': {
      padding: '70px 0 !important'
    }
  },
  unmuteButton: {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    border: 'none',
    padding: '10px',
    cursor: 'pointer',
    zIndex: 10
  },
  videoOpacity: {
    opacity: 0.3
  },
  dividerLine: {
    backgroundColor: '#595959',
    height: '93px',
    width: '0.5px',
    '@media screen and (max-width: 959px)': {
      height: '50px',
      backgroundColor: 'transparent !important'
    }
  },
  dividerWithCredentials: {
    '@media screen and (max-width: 959px)': {
      height: '25px'
    }
  }
}));

function Login() {
  const classes = useStyles();
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);
  const [credentialsVisible, setCredentialsVisible] = useState(false);

  const handleMuteToggle = () => {
    if (audioRef.current) {
      const newMutedState = !isMuted;
      audioRef.current.muted = newMutedState;
      setIsMuted(newMutedState);

      if (newMutedState) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = isMuted ? 0 : 1; // Controlar el volumen basado en isMuted
      audioRef.current.loop = true;
      if (!isMuted) {
        audioRef.current.play(); // Iniciar la reproducción si no está silenciado inicialmente
      }
    }
  }, [isMuted]);

  useEffect(() => {
    // Iniciar el audio en silencio al cargar la página
    if (audioRef.current) {
      audioRef.current.volume = 0;
    }
  }, []);

  return (
    <div className="overflow-hidden h-full">
      <video
        className={clsx(classes.videoOpacity, 'w-full h-full object-cover')}
        src={videoBackground}
        autoPlay
        loop
        muted
        playsInline
      />
      <audio ref={audioRef} src={backgroundMusic} loop />
      <div
        className={clsx(
          classes.root,
          'flex flex-col flex-auto items-center justify-center flex-shrink-0 md:p-24 absolute w-full h-full top-0'
        )}
      >
        <FuseAnimate animation="transition.expandIn">
          <div
            className={clsx(
              classes.loginModal,
              credentialsVisible && classes.loginModalCredentials,
              'flex items-center justify-center w-full  bg-white'
            )}
          >
            <div className={clsx(classes.leftSection, 'md:flex flex-1 items-center justify-center')}>
              <div className="max-w-340 flex md:text-center items-center justify-center">
                <FuseAnimate animation="transition.slideUpIn" delay={400}>
                  <img className={clsx(classes.loginLogo)} src="assets/images/logos/logo-icentral.png" alt="logo" />
                </FuseAnimate>
              </div>
            </div>
            <div className={clsx(classes.dividerLine, credentialsVisible && classes.dividerWithCredentials)}></div>
            <Card
              className={clsx(classes.rightSection, 'flex flex-col w-full')}
              style={credentialsVisible ? { marginBottom: 0 } : {}}
              square
              elevation={0}
            >
              <CardContent className={clsx(classes.loginForm, 'flex flex-col items-center justify-center w-full')}>
                <JWTLoginTab onShowCredentials={() => setCredentialsVisible(true)} />
                {/* <EncompassLoginButton /> */}
              </CardContent>
            </Card>
            <button className={classes.unmuteButton} onClick={handleMuteToggle}>
              {isMuted ? <VolumeOff className="text-26" /> : <VolumeUp className="text-26" />}
            </button>
          </div>
        </FuseAnimate>
      </div>
    </div>
  );
}

export default Login;
